import { formatearFechaCompleta } from '../../../../utils/utils'
import React, { useEffect, useState, useMemo } from 'react';
import { 
  Copy, 
  Video,
  KeyRound,
  Check,
  UserCheck, 
  FileCheck, 
  Bell, 
  DollarSign, 
  RotateCcw, 
  Eye, 
  AlertTriangle,
  FileText,
  AlertCircle,
  Settings,
  CheckCircle,
  XCircle,
  Send,
} from 'lucide-react';
import FileUploader from '../../../../components/FileUploader';

const ZonaEntregas = ({servicio,entregarTrabajo,handleSave,formData,setFormData}) => {
  return (
    <div>
        {/* ZONA DE ENTREGAS */}
          <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="px-6 py-4 border-b border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                </svg>
                Zona de Entregas
              </h3>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                
              {/* -------------------- SECCIÓN ENTREGA TUTOR -------------------- */}
              <div className="bg-white border border-indigo-100 rounded-xl shadow-sm overflow-hidden flex flex-col h-full">

                {/* Header Tutor */}
                <div className="bg-indigo-50 px-5 py-4 border-b border-indigo-100 flex items-center justify-between">
                  <h4 className="font-semibold text-indigo-900 flex items-center gap-2">
                    <div className="bg-indigo-200 p-1.5 rounded-lg">
                      {/* Icono de Gorro de graduación o libro */}
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-indigo-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l9-5-9-5-9 5 9 5z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
                      </svg>
                    </div>
                    Entrega del Tutor
                  </h4>
                  <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${
                    servicio?.getTrabajoEntregado() 
                      ? 'bg-green-100 text-green-700' 
                      : 'bg-red-100 text-red-700'
                  }`}>
                    {servicio?.getTrabajoEntregado() ? 'Completado' : 'Pendiente'}
                  </span>
                </div>

                {/* Condicional para subir trabajos o permitir resubir trabajo */}
                <div className="p-5 flex-1 flex flex-col justify-between gap-4">
                  
                  {/* Información de Estado */}
                  <div className="bg-gray-50 rounded-lg p-3 border border-gray-100">
                    <div className="flex justify-between items-center text-sm mb-1">
                      <span className="text-gray-500">Fecha de entrega:</span>
                      <span className="font-medium text-gray-800">
                        {servicio?.getTrabajoEntregado() && servicio.entregatutorFecha 
                          ? formatearFechaCompleta(servicio.entregatutorFecha) // O usa tu formateador
                          : '--/--/----'}
                      </span>
                    </div>
                  </div>

                  {/* ACCIONES DEL TUTOR */}
                  <div className="space-y-3 mt-2">
                    
                    {servicio?.getTrabajoEntregado() ? (
                      /* CASO: YA ENTREGADO */
                      <div className="space-y-3">
                        <div className="flex items-center gap-2 text-green-700 bg-green-50 p-3 rounded-lg text-sm">
                          <CheckCircle size={18} />
                          <span>El tutor ya ha subido los archivos.</span>
                        </div>
                        
                        <button 
                          onClick={() => handleSave('entregatutorFecha', new Date(2023, 0, 1))}
                          disabled={servicio?.getTrabajoEntregadoCliente()}
                          className={`
                            w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-sm font-medium transition-all shadow-sm border
                            ${servicio?.getTrabajoEntregadoCliente() 
                              ? 'bg-red-50 border-red-200 text-red-400 cursor-not-allowed opacity-75' // Estilo cuando está bloqueado (Rojo bajito y cursor de prohibido)
                              : 'bg-white border-red-200 text-red-600 hover:bg-red-50 hover:border-red-300' // Estilo normal interactivo
                            }
                          `}
                        >
                          <RotateCcw size={16} />
                            Permitir re-subir trabajo (Resetear)

                          {servicio?.getTrabajoEntregadoCliente() && (
                            <span className="text-[10px] font-bold uppercase mt-1">
                              NO PERMITIDO POR ENTREGA A CLIENTE
                            </span>
                          )}

                        </button>
                      </div>
                    ) : (
                      /* CASO: PENDIENTE */
                      <div className="space-y-3">
                        {/* Botón 1: Subir archivos manualmente (simulado) */}

                        <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                          </svg>
                          Subir archivos
                        </h3>

                        <FileUploader
                          formData={formData}
                          setFormData={setFormData}
                          fieldName="trabajos"
                          allowedTypes={[]}
                          maxSize={100 * 1024 * 1024}
                          label="trabajo"
                          multiple={true}
                        />

                        <button 
                          onClick={entregarTrabajo}
                          className={`px-6 py-3 rounded-lg transition-colors flex items-center justify-center gap-2 font-medium shadow-md ${'bg-green-600 text-white hover:bg-green-700 cursor-pointer' }`}
                          >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                          </svg>
                          Finalizar y entregar
                        </button>

                        <div className="relative flex py-1 items-center">
                          <div className="flex-grow border-t border-gray-200"></div>
                          <span className="flex-shrink-0 mx-2 text-gray-400 text-xs">O si ya envió por fuera</span>
                          <div className="flex-grow border-t border-gray-200"></div>
                        </div>

                        {/* Botón 2: Forzar entrega manual */}
                        <button 
                          onClick={() => handleSave('entregatutorFecha', new Date())}
                          className="w-full flex items-center justify-center gap-2 py-2.5 px-4 bg-white border border-indigo-200 text-indigo-700 rounded-lg text-sm font-medium hover:bg-indigo-50 transition-colors"
                        >
                          <FileCheck size={16} />

                          Trabajo No Entregado

                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* -------------------- SECCIÓN ENTREGA CLIENTE -------------------- */}
              <div className="bg-white border border-teal-100 rounded-xl shadow-sm overflow-hidden flex flex-col h-full">
                {/* Header Cliente */}
                <div className="bg-teal-50 px-5 py-4 border-b border-teal-100 flex items-center justify-between">
                  <h4 className="font-semibold text-teal-900 flex items-center gap-2">
                    <div className="bg-teal-200 p-1.5 rounded-lg">
                      <UserCheck size={20} className="text-teal-800"/>
                    </div>
                    Entrega al Cliente
                  </h4>
                  <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${
                    servicio?.getTrabajoEntregadoCliente() 
                      ? 'bg-green-100 text-green-700' 
                      : 'bg-red-100 text-red-700'
                  }`}>
                    {servicio?.getTrabajoEntregadoCliente() ? 'Entregado' : 'Pendiente'}
                  </span>
                </div>

                <div className="p-5 flex-1 flex flex-col justify-between gap-4">
                  
                  {/* Estado de notificación */}
                  <div className={`rounded-lg p-3 border flex items-center justify-between ${
                    servicio.avisoClienteEntrega 
                    ? 'bg-blue-50 border-blue-100 text-blue-800' 
                    : 'bg-gray-50 border-gray-100 text-gray-500'
                  }`}>
                    <div className="flex items-center gap-2 text-sm">
                      {servicio.avisoClienteEntrega ? <Bell size={16} className="text-blue-600"/> : <Bell size={16} />}
                      <span className="font-medium">
                        {servicio.avisoClienteEntrega ? 'Cliente notificado' : 'Cliente NO notificado'}
                      </span>
                    </div>
                    {/* Toggle rápido de notificación si lo necesitas */}
                    <button 
                      onClick={() => handleSave('avisoClienteEntrega', !servicio.avisoClienteEntrega)}
                      className="text-xs underline hover:text-blue-600"
                    >
                      Cambiar
                    </button>
                  </div>

                  {/* ACCIONES DEL CLIENTE */}
                  <div className="space-y-3 mt-2">
                    
                    {servicio?.getTrabajoEntregadoCliente() ? (
                      /* CASO: YA ENTREGADO A CLIENTE */
                      <div className="space-y-3">
                          <div className="flex items-center gap-2 text-teal-700 bg-teal-50 p-3 rounded-lg text-sm">
                            <CheckCircle size={18} />
                            <span>Trabajo entregado el {formatearFechaCompleta(servicio.entregaClienteFecha)}</span>
                          </div>

                          <button 
                            onClick={() => handleSave('entregaClienteFecha', new Date(2023, 0, 1))}
                            className="w-full flex items-center justify-center gap-2 py-2.5 px-4 bg-white border border-red-200 text-red-600 rounded-lg text-sm font-medium hover:bg-red-50 hover:border-red-300 transition-all shadow-sm"
                          >
                            <XCircle size={16} />
                            Deshacer entrega (Marcar NO entregado)
                          </button>
                      </div>
                    ) : (
                      /* CASO: PENDIENTE DE ENTREGAR A CLIENTE */
                      <div className="space-y-3">
                        <div className="p-3 bg-yellow-50 text-yellow-800 text-xs rounded-lg flex items-start gap-2">
                          <AlertTriangle size={14} className="mt-0.5 flex-shrink-0"/>
                          Asegúrate de que el trabajo del tutor esté correcto antes de enviar al cliente.
                        </div>

                        {/* Botón Principal: Entregar */}
                        <button 
                          onClick={() => handleSave('entregaClienteFecha', new Date())}
                          className="w-full flex items-center justify-center gap-2 py-2.5 px-4 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700 shadow-md transition-colors"
                        >
                          <Send size={18} />
                          Entregar trabajo al Cliente
                        </button>
                      </div>
                    )}

                  </div>
                </div>
              </div>

              </div>

              {/* Link de Entrega */}
              {servicio.linkEntregaTutor && servicio.linkEntregaTutor !== 'No ha sio entregao' && (
                <div className="mt-6">
                  <h5 className="text-sm font-medium text-gray-700 mb-2">Link de Entrega:</h5>

                  <button 
                    onClick={() => window.open(servicio.linkEntregaTutor, '_blank')}
                    className="w-full text-left bg-blue-50 border border-blue-200 rounded-lg p-3 hover:bg-blue-100 transition-colors"
                  >
                    <div className="flex items-center gap-2">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-blue-600 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.102m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                      </svg>
                      <span className="text-blue-700 text-sm truncate">{servicio.linkEntregaTutor}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-blue-600 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </div>

                  </button>

                </div>
              )}

            </div>
          </div>
    </div>
  )
}

export default ZonaEntregas
